import { render, staticRenderFns } from "./bindcoupon.vue?vue&type=template&id=3ca98f6c"
import script from "./bindcoupon.vue?vue&type=script&lang=js"
export * from "./bindcoupon.vue?vue&type=script&lang=js"
import style0 from "./bindcoupon.vue?vue&type=style&index=0&id=3ca98f6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports